import React, { useState } from "react";
import axios from "axios";
import {
  Alert,
  Box,
  Button,
  Container,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import MediaUploadField from "./MediaUploadField";

const initialState = {
  titulo: "",
  autor: "",
  instituicaoautor: "",
  imgcard: "",
  linkpdfdoclink: "",
  linkjsondocindex: "",
  autorDocumento: "",
  nomeDocumento: "",
  dataComposicao: "",
  lugarComposicaoOuImpressao: "",
  imagemDocumento: "",
  nomeImagemDocumento: "",
  palavrachave: "",
};

const stripHtml = (value = "") =>
  String(value).replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();

const DashBoardDocumentos = () => {
  const apiUrl = process.env.REACT_APP_API_URL || "/api";
  const [formData, setFormData] = useState(initialState);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ type: "success", text: "" });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const setFieldValue = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleUploadError = (message) => {
    setAlertMessage({ type: "error", text: message });
    setOpenSnackbar(true);
  };
  const handleUploadSuccess = (message) => {
    setAlertMessage({ type: "success", text: message });
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const token = localStorage.getItem("token");
    if (!token) {
      setAlertMessage({
        type: "error",
        text: "Você precisa estar autenticado para criar documentos.",
      });
      setOpenSnackbar(true);
      return;
    }

    const requiredFields = [
      ["Título", formData.titulo],
      ["Imagem do card", formData.imgcard],
      ["PDF do documento", formData.linkpdfdoclink],
    ];
    const missing = requiredFields
      .filter(([, value]) => !stripHtml(value))
      .map(([label]) => label);

    if (missing.length) {
      setAlertMessage({
        type: "error",
        text: `Preencha os campos obrigatórios: ${missing.join(", ")}.`,
      });
      setOpenSnackbar(true);
      return;
    }

    const payload = {
      titulo: formData.titulo.trim(),
      autor: formData.autor.trim() || "Documento Avulso",
      imgcard: formData.imgcard.trim(),
      linkpdfdoclink: formData.linkpdfdoclink.trim(),
      linkjsondocindex: formData.linkjsondocindex.trim(),
      autorDocumento: formData.autorDocumento.trim() || formData.autor.trim() || "N/A",
      nomeDocumento: formData.nomeDocumento.trim() || formData.titulo.trim(),
      dataComposicao: formData.dataComposicao.trim() || "N/A",
      lugarComposicaoOuImpressao: formData.lugarComposicaoOuImpressao.trim() || "N/A",
      imagemDocumento: formData.imagemDocumento.trim() || formData.imgcard.trim(),
      nomeImagemDocumento: formData.nomeImagemDocumento.trim() || "Documento avulso",
      palavrachave: formData.palavrachave.trim(),
    };

    try {
      await axios.post(`${apiUrl}/documentos`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setFormData(initialState);
      setAlertMessage({
        type: "success",
        text: "Documento avulso criado com sucesso.",
      });
      setOpenSnackbar(true);
    } catch (error) {
      const backendMessage = error?.response?.data?.error || error?.response?.data?.message;
      setAlertMessage({
        type: "error",
        text: backendMessage || "Erro ao criar documento avulso.",
      });
      setOpenSnackbar(true);
    }
  };

  return (
    <Container maxWidth="md">
      <hr style={{ margin: "40px 0", borderTop: "1px solid #ddd" }} />
      <hr style={{ margin: "40px 0", borderTop: "1px solid #ddd" }} />

      <Typography
        variant="h2"
        align="center"
        gutterBottom
        style={{
          fontFamily: "'Lato', serif",
          color: "black",
          borderBottom: "4px solid #d4af37",
          paddingBottom: "10px",
          textTransform: "uppercase",
          marginTop: "7%",
        }}
      >
        Cadastro de Documento Avulso
      </Typography>

      <Typography variant="body1" sx={{ mb: 3, textAlign: "center" }}>
        Use esta tela para documentos que nao possuem verbete. Eles entram na busca em documentos.
      </Typography>

      <form onSubmit={handleSubmit}>
        <Box mb={2}>
          <TextField fullWidth label="Titulo" name="titulo" value={formData.titulo} onChange={handleChange} required />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label="Autor (catalogo)" name="autor" value={formData.autor} onChange={handleChange} />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label="Instituicao do Autor" name="instituicaoautor" value={formData.instituicaoautor} onChange={handleChange} />
        </Box>
        <Box mb={2}>
          <MediaUploadField
            label="Imagem do card"
            name="imgcard"
            value={formData.imgcard}
            onChange={setFieldValue}
            folder="imagenscards"
            accept="image/*"
            required
            onError={handleUploadError}
            onSuccess={handleUploadSuccess}
          />
        </Box>
        <Box mb={2}>
          <MediaUploadField
            label="PDF do documento"
            name="linkpdfdoclink"
            value={formData.linkpdfdoclink}
            onChange={setFieldValue}
            folder="pdfDoc"
            accept=".pdf,application/pdf"
            required
            onError={handleUploadError}
            onSuccess={handleUploadSuccess}
          />
        </Box>
        <Box mb={2}>
          <MediaUploadField
            label="JSON indexado (opcional)"
            name="linkjsondocindex"
            value={formData.linkjsondocindex}
            onChange={setFieldValue}
            folder="pdfDoc"
            accept=".json,application/json,text/plain"
            onError={handleUploadError}
            onSuccess={handleUploadSuccess}
          />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label="Nome do documento" name="nomeDocumento" value={formData.nomeDocumento} onChange={handleChange} />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label="Autor do documento" name="autorDocumento" value={formData.autorDocumento} onChange={handleChange} />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label="Data de composicao" name="dataComposicao" value={formData.dataComposicao} onChange={handleChange} />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label="Lugar de composicao/impressao" name="lugarComposicaoOuImpressao" value={formData.lugarComposicaoOuImpressao} onChange={handleChange} />
        </Box>
        <Box mb={2}>
          <MediaUploadField
            label="Imagem interna do documento"
            name="imagemDocumento"
            value={formData.imagemDocumento}
            onChange={setFieldValue}
            folder="imagensverbete"
            accept="image/*"
            onError={handleUploadError}
            onSuccess={handleUploadSuccess}
          />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label="Descricao da imagem do documento" name="nomeImagemDocumento" value={formData.nomeImagemDocumento} onChange={handleChange} />
        </Box>
        <Box mb={3}>
          <TextField fullWidth label="Palavras-chave" name="palavrachave" value={formData.palavrachave} onChange={handleChange} />
        </Box>

        <Button type="submit" fullWidth variant="contained" color="primary">
          Criar Documento Avulso
        </Button>
      </form>

      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert severity={alertMessage.type} onClose={handleCloseSnackbar}>
          {alertMessage.text}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default DashBoardDocumentos;
